import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const getProductInventory = {
  name: "getProductInventory" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    quantity: z.bigint(),
    committed: z.bigint(),
    reserved: z.bigint(),
    available: z.bigint(),
  }),
};
